import { GoogleLocationType } from '@/types/enums/google-location-type.enum';
import { Place } from '@/types/google-maps.types';

export const isPreciseLocation = (place?: Place): boolean =>
  place?.locationType === GoogleLocationType.ROOFTOP
  || place?.locationType === GoogleLocationType.RANGE_INTERPOLATED;
